import { render } from "./Show.vue?vue&type=template&id=125be1fd"
import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Public/Proposal/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "125be1fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('125be1fd', __exports__)) {
    api.reload('125be1fd', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=125be1fd", () => {
    api.rerender('125be1fd', render)
  })

}


export default __exports__